import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
  selector: 'app-kf-next-report-step-bar',
  templateUrl: './kf-next-report-step-bar.component.html',
  styleUrls: ['./kf-next-report-step-bar.component.scss']
})
export class KfNextReportStepBarComponent implements OnInit {

  @Input()
  currentStep!: number;
  @Input()
  step2Completed!: boolean;

  @Output()
  loadStep: EventEmitter<number> = new EventEmitter<number>();

  constructor() { }

  ngOnInit(): void {
  }

  step(value: number): void {
    if (this.currentStep < value) {
      if (value === 2 && this.step2Completed) {
        this.loadStep.emit(value);
      }
      if (value === 3 && this.step2Completed) {
        this.loadStep.emit(value);
      }
    }
    else {
      this.loadStep.emit(value);
    }
  }

}
